import React from 'react';
import ReactDOM from 'react-dom/client';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';

import { Ion } from 'cesium';
import {
    Chart as ChartJS,
    LineController,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale,
    TimeSeriesScale,
    Colors,
} from 'chart.js';
import 'chartjs-adapter-luxon';

import store from 'store';
import { ENV, CESIUM_TOKEN } from 'config';
import App from 'App';
import ThemeInjector from 'theme/ThemeInjector';
import reportWebVitals from 'reportWebVitals';

import 'cesium/Widgets/widgets.css';

import 'index.css';

ChartJS.register(
    Tooltip,
    Legend,
    LineController,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale,
    TimeSeriesScale,
    Colors,
);

Ion.defaultAccessToken = CESIUM_TOKEN;

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);

root.render(
    <>
        <CssBaseline />
        <Provider store={store}>
            <ThemeInjector>
                <Router>
                    <App />
                </Router>
            </ThemeInjector>
        </Provider>
    </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (ENV !== 'prod') reportWebVitals(console.log);
